import { Navigate } from 'react-router'
import { useOrganization } from '../hooks/useOrganization'
import { organizationLandingPath } from '../config/studioRoutes'
import { LoadingSpinner } from './common/LoadingSpinner'

export default function OrganizationLandingRedirect() {
  const { currentOrg, loading, productsLoading } = useOrganization()

  if (loading || productsLoading) {
    return <LoadingSpinner message="Loading workspace" />
  }

  return <Navigate to={organizationLandingPath(currentOrg)} replace />
}
